import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import styled from 'styled-components';
import { theme } from '../theme';
export const StyledCard = styled.div`
  background: ${({ background })=>background || theme.colors.white};
  padding: ${theme.spaces.x24};
  border-radius: ${theme.radius.x12};
  ${({ hasHoverEffect: isHoverEffect })=>isHoverEffect ? '' : `
  transition: ${theme.transition.s};
  box-shadow: ${theme.shadows.sm};`}
  &:hover {
    background: ${({ background })=>background || theme.colors.white};
    box-shadow: ${({ hasHoverEffect: isHoverEffect })=>isHoverEffect ? theme.shadows.sm : theme.shadows.md};
  }
  &,
  &:hover {
    &[disabled] {
      background: inherit;
      box-shadow: none;
    }
  }
`;
export const Card = ({ hasHoverEffect: isHoverEffect, children, background, ...restProps })=>{
    return /*#__PURE__*/ _jsx(StyledCard, {
        hasHoverEffect: isHoverEffect,
        background: background,
        ...restProps,
        children: children
    });
};
